import { render, staticRenderFns } from "./farmersContent.vue?vue&type=template&id=609e6cb1&scoped=true&"
import script from "./farmersContent.vue?vue&type=script&lang=js&"
export * from "./farmersContent.vue?vue&type=script&lang=js&"
import style0 from "./farmersContent.vue?vue&type=style&index=0&id=609e6cb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609e6cb1",
  null
  
)

export default component.exports